export { ThankYouPage } from "./ThankYouPage";
